import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {NUMBER_RANGE_REDUCER_STATE_ID} from './number_range_constants';
import {NumberRangeMap} from './number_range_types';

export interface NumberRangeState {
  numberRangeMap: NumberRangeMap;
  isInitialized: boolean;
}

const initialState: NumberRangeState = {
  numberRangeMap: {},
  isInitialized: false,
};

export interface AddNumberRangeMapPayload {
  numberRangeMap: NumberRangeMap;
}

export const numberRangeSlice = createSlice({
  name: NUMBER_RANGE_REDUCER_STATE_ID,
  initialState,
  reducers: {
    addNumberRangeMap: (
      state,
      action: PayloadAction<AddNumberRangeMapPayload>
    ) => {
      state.numberRangeMap = {
        ...state.numberRangeMap,
        ...action.payload.numberRangeMap,
      };
      state.isInitialized = true;
    },
  },
});
